export default "__VITE_ASSET__6w9n0zAwOT6o4YSEhOTCAQ__";